import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import ApiClient from "../services/api-client"
import Select from 'react-select';
import { CustomConfirmAlert as confirmAlert } from '../components/custom-confirm-alert';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'
import InvoiceTypeSeriesEditableGrid from '../components/aggrids/editable-aggrids/invoicetype-series-grid'
import InvoiceTypeClassificationsGrid from '../components/aggrids/editable-aggrids/invoicetype-classifications-grid'
import Commons from '../util/commons'
import FormLayout from '../components/layout/form-layout'
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import useStore from "../hooks/useStore";


export default function InvoiceTypeSeriesAdd() {

    const { id } = useParams();
    const { t } = useTranslation();
    const validationSchema = Yup.object().shape({
        name: Yup.string().required(t("fieldRequired")),
        myDataInvoiceType: Yup.object().required(t("fieldRequired")).nullable(),
    });

    const [content, setContent] = useState({});
    const { register, getValues, control, handleSubmit, setValue, reset, formState: { errors }, trigger, clearErrors } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const navigate = useNavigate();
    const invoiceTypeSeriesGridRef = useRef();
    const [myDataInvoiceType, setMyDataInvoiceType] = useState();
    const [incomeClassCategories, setIncomeClassCategories] = useState();
    const [expensesClassCategories, setExpensesClassCategories] = useState();
    const [classCategories, setClassCategories] = useState();

    const [classificationValues, setClassificationValues] = useState();
    const [optionBranches, setOptionBranches] = useState([]);

    function formatModel(invoicetype) {

        const company = useStore.getState().selectedCompany;


        var _series = [];
        var seriesData = invoiceTypeSeriesGridRef.current.getData();

        seriesData.forEach(item => {
            if (item.name !== undefined && item.name !== "") {
                var ser = {
                    id: item.id,
                    name: item.name,
                    branch: { id: item.branch.value },
                    startNumber: item.startNumber,
                }
                _series.push(ser);
            }
        })

        var classificationCategory = getValues().classificationCategory;
        var classificationValue = getValues().classificationValue;
        var invoiceTypeClass = [];
        if (classificationCategory) {
            invoiceTypeClass = [
                {
                    classificationCategory: classificationCategory.value,
                    classificationValue: classificationValue.value,
                    selfPricing: getValues().selfPricing,
                    percent: true,
                    amount: 100
                }
            ]
        }

        var newInvType = {
            name: invoicetype.name,
            company: company,
            myDataInvoiceType: invoicetype.myDataInvoiceType.value,
            series: _series,
            invoiceTypeClassifications: invoiceTypeClass
        };
        if (id !== undefined) {
            newInvType.id = id;
        }

        return newInvType;
    }

    const onSubmit = (invoicetype, e) => {
        e.preventDefault()
        const companyId = useStore.getState().selectedCompany?.id;

        var entriesHasError = invoiceTypeSeriesGridRef.current.hasError() && invoiceTypeSeriesGridRef.current.getData().length > 0;

        if (entriesHasError) {
            toast.error(t("entriesErrors"), 5000)
            return;
        }
        var invtype = formatModel(invoicetype);
        console.debug(invtype);
        confirmAlert({
            title: t("submitConfirm"),
            message: t("areYouSure"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => ApiClient.saveCompanyInvoiceType(companyId, invtype).then(
                        response => {
                            if (id === undefined) {
                                navigate("/")
                                navigate("/invoiceType");
                            }
                            toast.success(t("saveSucceded"))
                            console.debug(response.data)
                            if (Commons.getDefaults("invoiceType")) {
                                Commons.setDefault("invoiceType", undefined);
                                Commons.setDefault("series", undefined);
                            }
                        },
                        error => {
                            toast.error("Error: " + error.response.data.message)
                            console.error(error.response.data)
                        }
                    )
                },
                {
                    label: t('No'),
                    onClick: () => {

                    }
                }
            ]
        });
    }

    const onDeleteClick = e => {
        e.preventDefault();
        confirmAlert({
            title: t('submitConfirm'),
            message: t('areYouSureToDelete'),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => ApiClient.deleteInvoiceType(id).then(
                        response => {
                            navigate("/invoicetypes");
                            toast.success("Delete succeded")

                        },
                        error => {
                            toast.error("Error: " + error.data)
                            console.error(error.data)
                        }
                    )
                },
                {
                    label: t('No')
                }
            ]
        });

    }

    useEffect(() => {
        const companyId = useStore.getState().selectedCompany?.id;

        ApiClient.getCompanyBranches(companyId).then(
            response => {
                var _data = response.data;
                var optionBranches = []
                _data.forEach(element => {
                    var _d = {
                        value: element.id,
                        label: element.name,
                        model: element,
                    }
                    optionBranches.push(_d)
                });
                setOptionBranches(optionBranches)
            },
            error => {
                setContent(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );


        ApiClient.getMyDataInvoiceTypes().then(response => {
            var data = response.data;
            var optionsExpenses = [];
            var optionsIncomes = [];
            var options = [];

            data.forEach(element => {

                var _enumVal = "invoice" + element.key.replace(".", "_");
                var postfix = " (" + element.myDataKey + ")";
                if (element.isExpense) {
                    optionsExpenses.push({
                        value: _enumVal,
                        label: t(_enumVal) + postfix,
                    });
                }
                else {
                    optionsIncomes.push({
                        value: _enumVal,
                        label: t(_enumVal) + postfix,
                    });
                }
            });

            options.push({
                options: optionsIncomes,
                label: t("InvoiceIncomes"),
            });

            options.push({
                options: optionsExpenses,
                label: t("InvoiceExpenses"),
            });

            if (id !== undefined) {
                ApiClient.getCompanyInvoiceType(companyId, id).then(
                    response => {
                        var type = response.data;

                        var invoiceTypeClassifications = type.invoiceTypeClassifications;
                        setContent({ invoicetype: response.data, myDataInvoiceTypes: options })
                        setValue("name", type.name)
                        setValue("myDataInvoiceType", { value: type.myDataInvoiceType, label: t(type.myDataInvoiceType) + " (" + type.myDataInvoiceTypeKey + ")" })
                        setMyDataInvoiceType(type.myDataInvoiceType)
                        getClassificationCategoriesOfInvoiceType(type.myDataInvoiceType)
                        setTimeout(function () {
                            invoiceTypeSeriesGridRef.current.setData(type.series);
                        }, 100)


                      if (invoiceTypeClassifications && invoiceTypeClassifications.length > 0) {
                            if (invoiceTypeClassifications[0].classificationCategory) {
                                var catNumber = invoiceTypeClassifications[0].classificationCategory.replace("CATEGORY_", "");

                                setValue("classificationCategory", {
                                    label: catNumber + ") " + t(invoiceTypeClassifications[0].classificationCategory),
                                    value: invoiceTypeClassifications[0].classificationCategory
                                })
                                setValue("classificationValue", {
                                    label: t(invoiceTypeClassifications[0].classificationValue) + " (" + invoiceTypeClassifications[0].classificationValue + ")",
                                    value: invoiceTypeClassifications[0].classificationValue
                                })
                                var opts = [];
                                invoiceTypeClassifications[0].classificationValues.forEach(element => {
                                    opts.push({
                                        value: element,
                                        label: t(element) + " (" + element + ")",
                                    });
                                });
                                setClassificationValues(opts)
                                setValue("selfPricing", invoiceTypeClassifications[0].selfPricing);
                            }
                        }
                    },
                    error => {
                        toast.error("Error: " + error.response.data.message)
                        console.error(error.response.data)
                    }
                );
            }
            else {
                reset();
                setContent({ invoicetype: null, myDataInvoiceTypes: options })
            }
        });
    }, [id]);
    var deleteBtn = "";
    if (id !== undefined) {
        deleteBtn = <button onClick={onDeleteClick} className="btn btn-danger deletebtn">
            {t("Delete")}
        </button>
    }

    const getClassificationCategoriesOfInvoiceType = (myDataInvoiceType) => {

        ApiClient.getClassificationCategoriesOfInvoiceType(myDataInvoiceType).then(response => {
            var dataIncomes = response.data.incomes;
            var dataExpenses = response.data.expenses;

            var _optionIncClassCategories = [];
            dataIncomes.forEach(element => {
                var _classificationCategory;
                var _classificationValues;
                _classificationCategory = element.classificationCategory;
                _classificationValues = element.classificationValues;
                var prefix = _classificationCategory.replace("CATEGORY_", "") + ") ";
                _optionIncClassCategories.push({
                    value: _classificationCategory,
                    label: prefix + t(_classificationCategory),
                    classificationValues: _classificationValues,
                });
            });
            var _optionExpClassCategories = [];
            dataExpenses.forEach(element => {
                var _classificationCategory;
                var _classificationValues;
                _classificationCategory = element.classificationCategory;
                _classificationValues = element.classificationValues;
                var prefix = _classificationCategory.replace("CATEGORY_", "") + ") ";
                _optionExpClassCategories.push({
                    value: _classificationCategory,
                    label: prefix + t(_classificationCategory),
                    classificationValues: _classificationValues,
                });
            });
            setIncomeClassCategories(_optionIncClassCategories);
            setExpensesClassCategories(_optionExpClassCategories);

            var selfPricing = getValues().selfPricing;

            var isExpense = Commons.isOnGroup(myDataInvoiceType, "isExpense") || selfPricing;

            if (isExpense) {
                setClassCategories(_optionExpClassCategories);
            }
            else {
                setClassCategories(_optionIncClassCategories);
            }
        },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );
    }

    const onInvoiceTypeChange = (val) => {
        if (id == undefined) {
            var ind = val.label.indexOf(" (")
            var name = val.label.substring(0, ind).trim();
            setValue("name", name);
            setValue("myDataInvoiceType", val)
            setMyDataInvoiceType(val.value);
            getClassificationCategoriesOfInvoiceType(val.value)

        }
        else {
            getClassificationCategoriesOfInvoiceType(content.myDataInvoiceType.value)
        }
        trigger();
    }




    const onClassificationCategoryChange = val => {

        setValue("classificationCategory", val);
        var opts = [];
        val.classificationValues.forEach(element => {
            opts.push({
                value: element,
                label: t(element) + " (" + element + ")",
            });
        });
        setClassificationValues(opts);
        setValue("classificationValue", null);

    }

    const onClassificationValueChange = val => {
        setValue("classificationValue", val);
    }


    const onChangeSelfPricing = (e) => {
        if (e.target.checked) {
            setClassCategories(expensesClassCategories)
            // setClassificationValues(opts);
        }
        else {
            setClassCategories(incomeClassCategories)
        }
        setValue("classificationCategory", null);
        setValue("classificationValue", null);

    }

    return (
        <div className="container" style={{ padding: 0 }}>
            <form id="invoice_type_form" onSubmit={handleSubmit(onSubmit)}>
                <FormLayout
                    headerRightContent={
                        <a className="btn btn-skin header-btn" onClick={function () { navigate("/invoicetypes") }}>
                            {t("invtypeSearch")}  <i className="fa fa-search"></i>
                        </a>
                    }
                    footer={
                        <div className="form-group text-center">
                            <button type="submit" className="btn btn-skin">
                                {t("Save")}
                            </button>
                            {deleteBtn}
                        </div>
                    }
                    title={t('invtypeAdd')}
                >
                    <div className="row">


                        <div className="col-md-4 form-group selectInputContainer required">
                            <label className="control-label inputlabel">{t("Type")}</label>
                            <Controller
                                render={({ field }) => (
                                    <Select {...field} onChange={onInvoiceTypeChange}
                                        inputId="invoicetype-react-select"
                                        options={content.myDataInvoiceTypes}
                                        className={`form-control ${errors.myDataInvoiceType ? 'is-invalid' : ''}`}
                                        isDisabled={id != null}
                                        placeholder={t("placeholderSelect")}
                                        styles={{
                                            menu: (provided, state) => ({
                                                ...provided,
                                                minWidth: 250,
                                                border: '4px #333',
                                                zIndex: 9999
                                            }),
                                            indicatorsContainer: (provided, state) => ({
                                                ...provided,
                                                padding: '0px',
                                            }),
                                            placeholder: (provided, state) => ({
                                                ...provided,
                                                fontSize: '12px',
                                            }),
                                            control: provided => ({
                                                ...provided,
                                                fontSize: '14px'
                                            })
                                        }}
                                    >

                                    </Select>
                                )}
                                control={control}
                                rules={{ required: true }}
                                name="myDataInvoiceType"

                                defaultValue=""
                            />


                            <div className="invalid-feedback">{errors.myDataInvoiceType?.message}</div>
                        </div>
                        <div className="col-md-4 form-group required textInputContainer">
                            <label className="control-label inputlabel">{t("Name")}</label>
                            <input
                                name="name"
                                type="text"
                                disabled={id != null}
                                {...register('name', { required: true, maxLength: 100 })}
                                placeholder={t("placeholderInput")}
                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                            />
                            <div className="invalid-feedback">{errors.name?.message}</div>
                        </div>

                    </div>
                    <div><br></br></div>
                    <div className="row">

                        <div className="col-md-12">
                            <div className="row">
                                <div className="offset-md-4 col-md-4">
                                    <h5 className="text-center">
                                        {t("invTypeSeries")}
                                    </h5>
                                </div>
                            </div>
                            <div className="alert alert-primary small-info" role="alert">
                                <p>{t("seriesNote")}</p>
                            </div>
                            <InvoiceTypeSeriesEditableGrid
                                ref={invoiceTypeSeriesGridRef}
                                optionBranches={optionBranches}
                                invoiceTypeId={id}>

                            </InvoiceTypeSeriesEditableGrid>
                        </div>
                    </div>
                    <div><br></br></div>

                    <div className="row" >
                        <div className="offset-md-4 col-md-4">
                            <h5 className="text-center">
                                {t("invoiceTypeClassifications")}
                            </h5>
                        </div>
                        <div className="col-md-12">
                            <div className="alert alert-primary small-info" role="alert">
                                <p>{t("invoiceTypeClassificationNote")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row" >

                        <div className="col-md-2  form-group selectInputContainer">
                            <label className="control-label inputlabel">{t("selfPricing")}</label>
                            <span className="editableCell">
                                <input name="selfPricing"
                                    {...register('selfPricing', { required: false })}
                                    onChange={onChangeSelfPricing}
                                    type="checkbox" >
                                </input>
                            </span>
                        </div>

                        <div className="col-md-4  form-group selectInputContainer">
                            <label className="control-label inputlabel">{t("ClassificationCategory")}</label>
                            <Controller
                                render={({ field }) => (
                                    <Select styles={{
                                        menu: (provided, state) => ({
                                            ...provided,
                                            minWidth: 250,
                                            border: '4px #333',
                                            zIndex: 9999
                                        }),
                                        indicatorsContainer: (provided, state) => ({
                                            ...provided,
                                            padding: '0px',
                                        }),
                                        placeholder: (provided, state) => ({
                                            ...provided,
                                            fontSize: '12px',
                                        }),
                                        control: provided => ({
                                            ...provided,
                                            fontSize: '14px'
                                        }),
                                    }}  {...field}
                                        onChange={onClassificationCategoryChange}
                                        options={classCategories}
                                        className={`form-control ${errors.branch ? 'is-invalid' : ''}`}
                                        placeholder={t('Select')}
                                    >

                                    </Select>
                                )}
                                control={control}
                                name="classificationCategory"
                                defaultValue=""
                            />
                        </div>


                        <div className="col-md-4 form-group selectInputContainer">
                            <label className="control-label inputlabel">{t("ClassificationValue")}</label>

                            <Controller
                                render={({ field }) => (
                                    <Select styles={{
                                        menu: (provided, state) => ({
                                            ...provided,
                                            minWidth: 250,
                                            border: '4px #333',
                                            zIndex: 9999
                                        }),
                                        indicatorsContainer: (provided, state) => ({
                                            ...provided,
                                            padding: '0px',
                                        }),
                                        placeholder: (provided, state) => ({
                                            ...provided,
                                            fontSize: '12px',
                                        }),
                                        control: provided => ({
                                            ...provided,
                                            fontSize: '14px'
                                        }),
                                    }}  {...field}
                                        onChange={onClassificationValueChange}
                                        options={classificationValues}
                                        className={`form-control ${errors.branch ? 'is-invalid' : ''}`}
                                        placeholder={t('Select')}
                                    >

                                    </Select>
                                )}
                                control={control}
                                name="classificationValue"
                                defaultValue=""
                            />
                        </div>
                    </div>


                    <div><br></br></div>
                </FormLayout>
            </form>

            <div><br></br></div>
        </div>
    );
}